import intl from "react-intl-universal";
import { Link } from "react-router-dom";
import { TbArrowLeft, TbPercentage } from "react-icons/tb";
import { BAAS_CARTOES_PATH } from "../constants";

/** Rebate — no partner API yet; empty state instead of a blank dead-end. */
export const BaasCartoesRebatePage = () => (
  <div className="baas-processing min-w-0 space-y-5">
    <header className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0">
        <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
          {intl.get("baas.nav.cartoes")}
        </p>
        <h1 className="mt-1 text-2xl font-bold text-brand-dark dark:text-gray-100">
          {intl.get("baas.cartoes.comingSoon.rebateTitle")}
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {intl.get("baas.cartoes.comingSoon.rebateBody")}
        </p>
      </div>
      <Link to={BAAS_CARTOES_PATH} className="btn-outline w-auto shrink-0 self-start !text-xs">
        <TbArrowLeft className="h-4 w-4" />
        {intl.get("baas.cartoes.comingSoon.backToPrograms")}
      </Link>
    </header>

    <div className="app-card flex min-h-[280px] flex-col items-center justify-center gap-3 p-8 text-center">
      <div className="summary-card-icon">
        <TbPercentage className="h-5 w-5" aria-hidden />
      </div>
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
        {intl.get("baas.cartoes.rebatePage.comingSoon")}
      </p>
      <p className="max-w-md text-sm text-gray-500 dark:text-gray-400">
        {intl.get("baas.cartoes.comingSoon.rebateBody")}
      </p>
    </div>
  </div>
);
